/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Octagon = [
  "svg",
  defaultAttributes,
  [
    [
      "polygon",
      { points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2" }
    ]
  ]
];

export { Octagon as default };
//# sourceMappingURL=octagon.js.map
